import axios from 'axios';

const list = (data) => axios.get('/custom/qualifications/list', data);
const save = (data) => axios.post('/custom/qualifications/saveOrUpdate', data);
const del = (data) => axios.post('/custom/qualifications/delete', data); //delete

export default {
  list,
  save,
  del,
}


